import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  Platform,
  View,
  TouchableOpacity,
  ActivityIndicator,
  Modal,
  Animated,
  useAnimatedValue,
  Text,
  FlatList,
  KeyboardAvoidingView,
} from 'react-native';
import {
  ListItem,
  Input,
  Button,
  ButtonGroup,
} from 'react-native-elements';
import Autolink from 'react-native-autolink';
import { matchPath } from 'react-router-dom';
import { ifIphoneX } from 'react-native-iphone-x-helper';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';
import md5 from 'md5';
import { fetchAuthSession } from '@aws-amplify/auth';
// import RNFetchBlob from './fetch';

import { AppSyncClientUnauthenticated, AppSyncClientAuthenticated } from '../../backends/AppSyncClient';
import GetApp from '../../q/GetApp';
import CheckMyLease from '../../q/CheckMyLease';
import CreateFreeLease from '../../q/CreateFreeLease';
import UpdateLease from '../../q/UpdateLease';
import QueryMyLeases from '../../q/QueryMyLeases';
import QueryMyHistory from '../../q/QueryMyHistory';
import UpdateOutput from '../../q/UpdateOutput';
import App from '../../modules/data/App';
import EndpointBadge from '../../components/apps/EndpointBadge';
import EndpointGraph from '../../components/apps/EndpointGraph';
import Endpoint from '../../modules/data/Endpoint';
import ScrollFading from '../../components/effects/ScrollFading';

import AORTypes from '../../types';
import styles from '../../styles';
import { translate, translateTime } from '../../locales/i18n';

// function sleepFor(sleepDuration) {
//   const now = new Date().getTime();
//   while (new Date().getTime() < now + sleepDuration) { /* do nothing */ }
// }

// const API_URL = 'https://api.aionrails.com/production';
const API_URL = 'https://j64up4hf4i.execute-api.us-west-2.amazonaws.com/production';

class AppQuery extends React.Component {
  static getAppQueryState(props, state) {
    const { location, app } = props;
    const { selectedInput } = state;

    if (app && !app.pp) {
      app.postProcess();
    }

    if (!app || !app.pp || !app.pp.endpoints) {
      return { endpoint: null };
    }

    const match = matchPath('/ai-agent/online/:uuid/:endpointUuid/:page?/:itemIndex?', location.pathname);
    const endpointUuid = match ? match.params.endpointUuid : undefined;
    const page = match ? match.params.page : 'query';
    const itemIndex = Number.parseInt(match && match.params.itemIndex, 10) || 0;

    let endpoint = app.pp.endpoints.find((e) => e.uuid === endpointUuid);
    if (endpoint) {
      endpoint = Endpoint.createFromData(endpoint);
      endpoint.postProcess();
    }

    console.log('endpoint:');
    console.log(endpoint);

    const displayingState = {
      displayingHistory: false,
      displayingIntegrations: false,
      displayingQuery: true,
      selectedInput: selectedInput === -1 ? 0 : selectedInput,
      itemIndex,
    };

    if (page === 'history') {
      displayingState.displayingHistory = true;
      displayingState.displayingIntegrations = false;
      displayingState.displayingQuery = false;
      displayingState.selectedInput = -1;
    } else if (page === 'integrations') {
      displayingState.displayingHistory = false;
      displayingState.displayingIntegrations = true;
      displayingState.displayingQuery = false;
      displayingState.selectedInput = -1;
    }

    return {
      endpoint,
      ...displayingState,
    };
  }

  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'AppQuery';

    this.updateToken = this.updateToken.bind(this);
    this.setModalVisible = this.setModalVisible.bind(this);
    this.onHistoryUpdate = this.onHistoryUpdate.bind(this);
    this.doGetOutput = this.doGetOutput.bind(this);

    this.state = {
      token: undefined,
      isModalVisible: false,
      starting: false,
      ...AppQuery.getAppQueryState(props, { selectedInput: 0 }),
      inputs: {},
      myHistory: [],
    };

    // this.fadeAnim = useAnimatedValue(0);
    this.fadeAnim = new Animated.Value(0);

    this.getOutputTimer = null;

    this.scrollRef = null;
    this.inputRefs = {};
  }

  componentDidMount() {
    Animated.timing(this.fadeAnim, {
      fromValue: 0,
      toValue: 1,
      duration: 600,
      useNativeDriver: true,
    }).start();

    this.onHistoryUpdate();
    setTimeout(() => this.updateToken(), 10);
    this.updateTokenTimer = setInterval(() => this.updateToken(), 900000);
  }

  componentDidUpdate(prevProps) {
    const { onQueryMyHistory } = this.props;
    if (onQueryMyHistory !== prevProps.onQueryMyHistory) {
      this.onHistoryUpdate();
    }
  }

  componentWillUnmount() {
    clearInterval(this.updateTokenTimer);
    if (this.getOutputTimer) {
      clearTimeout(this.getOutputTimer);
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    console.log('getDerivedStateFromProps');
    console.log(nextProps);
    if (nextProps.app) {
      return AppQuery.getAppQueryState(nextProps, prevState);
    }
    return {};
  }

  onHistoryUpdate() {
    const { onQueryMyHistory, app } = this.props;
    const { itemIndex, endpoint } = this.state;

    if (app && endpoint && onQueryMyHistory && onQueryMyHistory.items && onQueryMyHistory.items.length > itemIndex) {
      this.setState({ myHistory: onQueryMyHistory.items }, () => {
        this.doGetOutput(app, endpoint, onQueryMyHistory.items[itemIndex].idRequest);
      });
    }
  }

  setModalVisible() {
    this.setState({ isModalVisible: true });
  }

  async updateToken() {
    fetchAuthSession().then(({ tokens }) => {
      if (!tokens) {
        console.log('no tokens');
        return;
      }
      console.log(`got token: ${tokens.accessToken}`);
      this.setState({ token: tokens.accessToken });
    });
  }

  doGetOutput(app, endpoint, idRequest) {
    const { onUpdateOutput } = this.props;
    const { myHistory } = this.state;

    console.log('doGetOutput');
    console.log(app);
    console.log(endpoint);
    console.log(idRequest);

    console.log('onUpdateOutput');
    console.log(onUpdateOutput);
    onUpdateOutput(app.data.uuid, endpoint.data.uuid, idRequest).then((data) => {
      console.log(data.data);
      if (data.data.updateOutput.output || data.data.updateOutput.error) {
        // We've got at least something out
        this.getOutputTimer = null;

        if (myHistory && myHistory.length > 0) {
          console.log('myHistory.items');
          console.log(myHistory);
          const item = myHistory.find((i) => i.idRequest === idRequest);
          if (item) {
            // This should always be a case
            item.output = data.data.updateOutput.output;
            item.error = data.data.updateOutput.error;
            item.errorMessage = data.data.updateOutput.errorMessage;
            // this.setState({ myHistory });
            this.forceUpdate();
          }
        }
      } else {
        // We've got nothing out, let's try again later
        this.getOutputTimer = setTimeout(() => this.doGetOutput(app, endpoint, idRequest), 5000);
      }
    }).catch((error) => {
      console.log(error);
      this.getOutputTimer = setTimeout(() => this.doGetOutput(app, endpoint, idRequest), 5000);
    });
  }

  query(app, endpoint) {
    const { onQueryMyHistory, history, onQueryMyHistoryRefetch } = this.props;
    const { inputs, token } = this.state;

    const formData = new FormData();
    Object.keys(inputs).forEach((key) => {
      formData.append(key, inputs[key]);
    });
    formData.append('app', app.data.uuid);
    formData.append('endpoint', endpoint.data.uuid);

    this.setState({ starting: true });

    const url = `${API_URL}/web/${app.data.uuid}/${endpoint.data.uuid}`;
    fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    })
      .then((response) => {
        console.log('response');
        console.log(response);

        console.log('refetching my history');
        console.log(onQueryMyHistory);
        console.log(onQueryMyHistoryRefetch);
        onQueryMyHistoryRefetch();
        setTimeout(() => onQueryMyHistoryRefetch(), 1000);
        setTimeout(() => onQueryMyHistoryRefetch(), 5000);
        setTimeout(() => onQueryMyHistoryRefetch(), 17000);

        this.setState({ starting: false });
        history.push(`/ai-agent/online/${app.data.uuid}/${endpoint.data.uuid}/history`);

        return response.json();
      })
      .then((data) => {
        console.log(data);
        this.setState({ starting: false });
      });
  }

  render() {
    const {
      direction, app, history,
      getAnalyticsService,
      existingLease,
      onCreateFreeLease,
      user,
      userData,
    } = this.props;
    const {
      isModalVisible, starting,
      endpoint,
      selectedInput,
      displayingQuery,
      displayingHistory,
      displayingIntegrations,
      myHistory,
      itemIndex,
    } = this.state;

    if (!app || !app.data || endpoint === undefined) {
      // console.error('no app');
      // return (<></>);
      // if (Platform.OS === 'web') {
      //   sleepFor(3000);
      // }

      return (
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
          }}
        >
          <Text
            style={{
              marginBottom: 20,
            }}
          >
            {translate('view_loading')}
          </Text>
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      );
    }

    app.postProcess();

    console.log('Create publisher from the app:');
    console.log(app);

    // const buttons = [
    //   'Walking',
    //   'Cycling',
    //   'Driving',
    //   'Teleport',
    // ];

    const mapRadius = 20;
    if (Platform.OS === 'web') {
      // fixGoogleMapsWebStyles(direction);
    }

    const tags = [];
    if (app.pp.tags) {
      app.pp.tags.forEach((tag, index) => {
        tags.push({ value: tag, count: 7 - index });
      });
    } else {
      if (app.data.tag1) {
        tags.push({ value: app.data.tag1, count: 7 });
      }
      if (app.data.tag2) {
        tags.push({ value: app.data.tag2, count: 6 });
      }
      if (app.data.tag3) {
        tags.push({ value: app.data.tag3, count: 5 });
      }
      if (app.data.tag4) {
        tags.push({ value: app.data.tag4, count: 4 });
      }
      if (app.data.tag5) {
        tags.push({ value: app.data.tag5, count: 3 });
      }
    }

    // const fadeIn = () => {
    //   // Will change fadeAnim value to 1 in 5 seconds
    //   Animated.timing(this.fadeAnim, {
    //     fromValue: 0,
    //     toValue: 1,
    //     duration: 5000,
    //     useNativeDriver: true,
    //   }).start();
    // };

    const inputs = JSON.parse(JSON.stringify(endpoint.pp.proto?.input));
    console.log('inputs:');
    console.log(inputs);

    const showHistoryTab = (myHistory && myHistory.length > 0) || displayingHistory;

    return (
      // <View
      <KeyboardAvoidingView
        behavior="padding"
        style={[styles.view.headed, {
          flex: 1,
          marginBottom: 0,
          paddingBottom: 0,
        }]}
      >
        <View style={{
          flex: 1,
          flexDirection: direction,
          width: '100%',
        }}
        >
          <View style={{ flex: 1, backgroundColor: '#f0f0f0' }}>
            <View style={{
              position: 'absolute',
              top: ifIphoneX(88, 0),
              left: 0,
              right: 0,
              bottom: mapRadius,
            }}
            >
              <View style={{
                flex: 1,
                alignItems: 'center',
                justifyContent: 'center',
                alignSelf: 'center',
                // borderWidth: 1,
                // borderColor: 'red',
                marginRight: direction === 'column' ? 0 : mapRadius,
              }}
              >
                <Animated.View style={{
                  opacity: this.fadeAnim,
                }}
                >
                  <EndpointGraph
                    endpoint={endpoint}
                    selectedInput={selectedInput}
                    content={displayingHistory && myHistory && myHistory.length > itemIndex ? myHistory[itemIndex] : undefined}
                  />
                  {/* <ArcherContainer
                    svgContainerStyle={{
                      display: 'flex',
                      flex: 1,
                    }}
                  >
                    <View
                      style={{
                        flex: 1,
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      {endpoint.pp.proto?.input.map((i, idx) => (
                        <ArcherElement
                          key={i.name}
                          id={`input${idx + 1}`}
                          relations={[
                            {
                              targetId: 'process',
                              targetAnchor: 'top',
                              sourceAnchor: 'bottom',
                              style: {
                                strokeColor: styles.primaryColor,
                                strokeWidth: 1,
                              },
                            },
                          ]}
                        >
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: styles.primaryFont300,
                              paddingHorizontal: 10,
                              paddingVertical: 10,
                              backgroundColor: styles.primaryColorWithOpacity,
                              borderColor: styles.primaryColor,
                              borderWidth: 1,
                              borderRadius: 8,
                              margin: 10,
                              textAlign: 'center',
                              textWrap: 'wrap',
                              opacity: selectedInput === idx ? 1 : 0.2,
                            }}
                          >
                            {i.d}
                          </Text>
                        </ArcherElement>
                      ))}
                    </View>
                    <View
                      style={{
                        flex: 1,
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <ArcherElement
                        id="process"
                      >
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: styles.primaryFont300,
                            paddingHorizontal: 30,
                            paddingVertical: 10,
                            backgroundColor: styles.primaryColor,
                            borderColor: styles.primaryColor,
                            borderWidth: 1,
                            borderRadius: 8,
                            margin: 30,
                            textAlign: 'center',
                            opacity: 0.15,
                          }}
                        >
                          AI Agent endpoint name
                        </Text>
                      </ArcherElement>
                    </View>
                    <View
                      style={{
                        flex: 1,
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      {endpoint.pp.proto?.output.map((o, idx) => (
                        <ArcherElement
                          key={o.name}
                          id={`output${idx + 1}`}
                          relations={[
                            {
                              targetId: 'process',
                              targetAnchor: 'bottom',
                              sourceAnchor: 'top',
                              style: {
                                strokeColor: styles.primaryColor,
                                strokeWidth: 1,
                              },
                            },
                          ]}
                        >
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: styles.primaryFont300,
                              paddingHorizontal: 10,
                              paddingVertical: 10,
                              backgroundColor: styles.primaryColorWithOpacity,
                              borderColor: styles.primaryColor,
                              borderRadius: 8,
                              margin: 10,
                              textAlign: 'center',
                              opacity: 0.2,
                            }}
                          >
                            {o.d}
                          </Text>
                        </ArcherElement>
                      ))}
                    </View>
                  </ArcherContainer> */}
                </Animated.View>
                {/* <Svg
                  style={{
                  }}
                  width="100%"
                  height="100%"
                >
                  <defs>
                    <marker
                      id="triangle"
                      viewBox="0 0 10 10"
                      refX="0"
                      refY="5"
                      markerUnits="strokeWidth"
                      markerWidth="10"
                      markerHeight="8"
                      orient="auto"
                      stroke={styles.primaryColor}
                      fill={styles.primaryColor}
                    >
                      <path d="M 0 0 L 10 5 L 0 10 z" />
                    </marker>
                  </defs>
                  <SvgText x="100" y="100" fontSize="12" fontFamily="Arial" fill="black">input1</SvgText>
                  <SvgText x="200" y="100" fontSize="12" fontFamily="Arial" fill="black">input2</SvgText>
                  <SvgText
                    style={{
                      borderWidth: 1,
                      borderColor: styles.primaryColor,
                    }}
                    x="140"
                    y="200"
                    fontSize="12"
                    fontFamily="Arial"
                    fill="black"
                    borderColor={styles.primaryColor}
                    borderWidth={1}
                  >
                    langgraph
                  </SvgText>
                  <SvgText x="150" y="300" fontSize="12" fontFamily="Arial" fill="black">output</SvgText>
                  <path d="M 120 110 C 120 150 160 150 160 175" fill="none" stroke={styles.primaryColor} markerEnd="url(#triangle)" />
                  <path d="M 220 110 C 220 150 180 150 180 175" fill="none" stroke={styles.primaryColor} markerEnd="url(#triangle)" />
                  <path d="M 170 210 C 170 230 170 270 170 275" fill="none" stroke={styles.primaryColor} markerEnd="url(#triangle)" />
                </Svg> */}
              </View>
            </View>
          </View>
          {/* Outer view that is responsible for absolute positioning _ADJACENT_ to the map */}
          <View
            style={direction === 'column' ? {
              flex: displayingHistory ? 1 : 1.5,
            } : {
              flex: 1,
              maxWidth: 640,
            }}
          // itemScope
          // itemType="http://schema.org/ConsumerDestination"
          >
            {/* Inner view that is responsible to get _ON TOP_ of the map */}
            {/* <KeyboardAvoidingView
              behavior="padding" */}
            <View
              style={[{
                position: 'absolute',
                overflow: 'hidden',
                backgroundColor: 'white',
                alignItems: 'center',
              }, direction === 'column' ? {
                top: -mapRadius,
                bottom: 0,
                width: '100%',
                borderTopLeftRadius: mapRadius,
                borderTopRightRadius: mapRadius,
              } : {
                left: -mapRadius,
                right: 0,
                height: '100%',
                borderTopLeftRadius: mapRadius,
                borderBottomLeftRadius: mapRadius,
              }]}
            >
              <ScrollFading
                scrollRef={(ref) => {
                  this.scrollRef = ref;
                }}
                containerStyle={{
                  maxWidth: 400,
                  width: '100%',
                }}
                style={{
                  flex: 1,
                  // overflow: 'hidden',
                  scrollbarWidth: 'none',
                }}
              >
                <EndpointBadge
                  endpoint={endpoint}
                  onTrackComplete={this.setModalVisible}
                  getAnalyticsService={getAnalyticsService}
                  single
                />
                {/* The following button group looks like tabs in a faile folder */}
                <ButtonGroup
                  selectedIndex={displayingHistory ? 1 : displayingIntegrations ? (myHistory && myHistory.length > 0 ? 2 : 1) : 0}
                  buttons={[
                    translate('button_new_query'),
                    ...(showHistoryTab ? [translate('button_history')] : []),
                    translate('button_integrations'),
                  ]}
                  onPress={(value) => {
                    // this.setState({
                    //   displayingHistory: value === 1,
                    //   displayingIntegrations: value === 2,
                    //   selectedInput: 0,
                    // });
                    if (value === 1) {
                      if (showHistoryTab) {
                        history.push(`/ai-agent/online/${app.data.uuid}/${endpoint.data.uuid}/history`);
                      } else {
                        history.push(`/ai-agent/online/${app.data.uuid}/${endpoint.data.uuid}/integrations`);
                      }
                    } else if (value === 2) {
                      history.push(`/ai-agent/online/${app.data.uuid}/${endpoint.data.uuid}/integrations`);
                    } else {
                      history.push(`/ai-agent/online/${app.data.uuid}/${endpoint.data.uuid}/query`);
                    }
                  }}
                  innerBorderStyle={{
                    width: 0,
                  }}
                  containerStyle={{
                    borderWidth: 0,
                    borderRadius: 0,
                    marginHorizontal: 0,
                    marginBottom: 20,
                    borderBottomWidth: 1,
                    borderBottomColor: styles.primaryColor,
                    height: 50,
                  }}
                  buttonStyle={[
                    styles.button.secondary,
                    {
                      borderBottomWidth: 0,
                      borderBottomRadius: 0,
                      // backgroundColor: 'transparent',
                      borderWidth: 0,
                      paddingBottom: 30,
                      paddingTop: 20,
                    },
                  ]}
                  selectedButtonStyle={[
                    styles.button.primary,
                    {
                      borderBottomWidth: 0,
                      borderBottomRadius: 0,
                      marginBottom: 0,
                      paddingBottom: 30,
                      paddingTop: 20,
                    },
                  ]}
                  textStyle={{
                    fontSize: 14,
                  }}
                  selectedTextStyle={{
                    fontSize: 14,
                    fontWeight: 'bold',
                  }}
                />
                {displayingQuery && inputs.length > 0 && inputs.map((v, i) => {
                  if (v.t === 'text') {
                    const key = md5(`${v.n}-${i}`);
                    return (
                      <>
                        <Text
                          key={`${key}-desc`}
                          ref={(ref) => {
                            this.inputRefs[i] = ref;
                          }}
                          style={{
                            marginHorizontal: 8,
                            fontSize: 16,
                            fontWeight: 'normal',
                          }}
                        >
                          {v.d}
                        </Text>
                        <Input
                          key={v.n}
                          disabled={!user}
                          placeholder={user ? '' : translate('signin_first')}
                          multiline={v.s > 1}
                          numberOfLines={v.s}
                          style={{
                            marginHorizontal: 8,
                            fontSize: 16,
                            fontWeight: 'normal',
                            borderColor: styles.primaryColor,
                            borderWidth: 1,
                            borderRadius: 8,
                            marginBottom: 10,
                            paddingHorizontal: 10,
                            paddingVertical: 10,
                          }}
                          containerStyle={{
                            paddingHorizontal: 0,
                          }}
                          inputContainerStyle={{
                            paddingHorizontal: 0,
                            borderBottomWidth: 0,
                          }}
                          // autoFocus={selectedInput === i}
                          onFocus={() => {
                            this.setState({ selectedInput: i }, () => {
                              // console.log('onFocus', i);
                              // console.log('scrollRef', this.scrollRef);
                              // console.log('inputRefs', this.inputRefs);
                              if (this.scrollRef && this.inputRefs[i]) {
                                const inputRect = this.inputRefs[i].getBoundingClientRect();
                                const scrollNode = this.scrollRef.getScrollableNode();

                                // console.log('inputRect', inputRect);
                                // console.log('scrollNode', scrollNode);

                                if (scrollNode) {
                                  const scrollRect = scrollNode.getBoundingClientRect();
                                  const scrollOffset = inputRect.top - scrollRect.top + scrollNode.scrollTop;
                                  // console.log('scrollOffset', scrollOffset);
                                  scrollNode.scrollTo({
                                    top: scrollOffset, // Incorrect?
                                    y: scrollOffset,
                                    behavior: 'smooth',
                                    animated: true,
                                  });
                                }
                              }
                            });
                          }}
                          onChangeText={(text) => {
                            // eslint-disable-next-line react/no-direct-mutation-state, react/destructuring-assignment
                            this.state.inputs[v.n] = text;
                          }}
                        // value={inputs[v.n] || ''}
                        />
                      </>
                    );
                  }
                  return null;
                })}
                {displayingHistory && (
                  <View>
                    {(!myHistory || myHistory.length === 0) && (
                      <>
                        <Text
                          style={{
                            marginHorizontal: 8,
                            fontSize: 14,
                            fontFamily: styles.primaryFont300,
                            textAlign: 'flex-start',
                          }}
                        >
                          {translate('no_history')}
                        </Text>
                        <ActivityIndicator
                          size="large"
                          color={styles.primaryColor}
                          style={{
                            marginTop: 20,
                          }}
                        />
                      </>
                    )}
                    {myHistory && myHistory.length > 0 && (
                      <ScrollFading
                        containerStyle={{
                          maxWidth: 400,
                          width: '100%',
                        }}
                        style={{
                          flex: 1,
                          paddingVertical: 5,
                          // overflow: 'hidden',
                          scrollbarWidth: 'none',
                        }}
                      >
                        {/* <Text
                          style={{
                            marginHorizontal: 8,
                            fontSize: 14,
                            fontFamily: styles.primaryFont300,
                            textAlign: 'flex-start',
                          }}
                        >
                          {translate('history_intro')}
                        </Text> */}
                        <FlatList
                          style={{
                            marginTop: 10,
                          }}
                          data={myHistory}
                          renderItem={({ item, index }) => {
                            // const date = new Date(item.timestamp);
                            const now = Date.now();
                            const diff = now / 1000.0 - item.timestamp;
                            const timeAgo = translate('time_ago', { time: translateTime(diff) });
                            return (
                              <ListItem
                                bottomDivider
                                onPress={() => {
                                  history.push(`/ai-agent/online/${app.data.uuid}/${endpoint.data.uuid}/history/${index}`);
                                }}
                              >
                                <ListItem.Content>
                                  <ListItem.Title
                                    style={{
                                      fontSize: 12,
                                      fontWeight: itemIndex === index ? 'bold' : 'normal',
                                    }}
                                  >
                                    {timeAgo}
                                  </ListItem.Title>
                                </ListItem.Content>
                              </ListItem>
                            );
                          }}
                        />
                      </ScrollFading>
                    )}
                  </View>
                )}
                {displayingIntegrations && (
                  <View
                    style={{
                      marginHorizontal: 8,
                    }}
                  >
                    <Button
                      title={translate('integrations_token')}
                      containerStyle={{
                        alignSelf: 'center',
                        paddingBottom: 10,
                        // paddingRight: 12,
                      }}
                      buttonStyle={styles.button.secondary}
                      disabledStyle={styles.button.secondaryDisabled}
                      titleStyle={styles.button.secondaryTitle}
                      disabledTitleStyle={styles.button.secondaryTitleDisabled}
                      onPress={() => {
                        history.push('/token');
                      }}
                    />
                    <Text>
                      {translate('integrations_intro')}
                    </Text>
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        marginTop: 20,
                        marginBottom: 10,
                      }}
                    >
                      {translate('integrations-a2a-title')}
                    </Text>
                    <Text>
                      <Autolink
                        text={translate('integrations-a2a-text', {
                          url: `${API_URL}/a2a/${app.data.uuid}/${endpoint.data.uuid}`,
                        })}
                        style={{
                          fontFamily: styles.primaryFont300,
                          fontSize: 12,
                          fontWeight: 'normal',
                        }}
                      />
                    </Text>
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        marginTop: 20,
                        marginBottom: 10,
                      }}
                    >
                      {translate('integrations-cli-title')}
                    </Text>
                    <Text
                      style={{
                        fontFamily: styles.primaryFont300,
                        backgroundColor: styles.primaryColorWithOpacity,
                        borderWidth: 1,
                        borderColor: styles.primaryColor,
                        borderRadius: 4,
                        paddingHorizontal: 10,
                        paddingVertical: 10,
                        fontSize: 12,
                        fontWeight: 'normal',
                      }}
                    >
                      {`$ pip install -U aor\n$ aor execute --app ${app.data.uuid} --endpoint ${endpoint.data.uuid} `}
                      {inputs.map((input) => {
                        return `--input ${input.n} <${input.d}>`;
                      })}
                      {/* {translate('integrations-cli-text', {
                        app: app.data.uuid,
                        endpoint: endpoint.data.uuid,
                      })} */}
                    </Text>
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        marginTop: 20,
                        marginBottom: 10,
                      }}
                    >
                      {translate('integrations-web-title')}
                    </Text>
                    <Text
                      style={{
                        fontFamily: styles.primaryFont300,
                        backgroundColor: styles.primaryColorWithOpacity,
                        borderWidth: 1,
                        borderColor: styles.primaryColor,
                        borderRadius: 4,
                        paddingHorizontal: 10,
                        paddingVertical: 10,
                        fontSize: 12,
                        fontWeight: 'normal',
                      }}
                    >
                      {`const formData = new FormData();

`}
                      {inputs.map((input) => {
                        return `formData.append("${input.n}", "<${input.d}>");`;
                      })}
                      {`

const url = \`${API_URL}/web/${app.data.uuid}/${endpoint.data.uuid}\`;
fetch(url, {
  method: 'POST',
  body: formData,
})
  .then((response) => response.json())`}
                    </Text>
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        marginTop: 20,
                        marginBottom: 10,
                      }}
                    >
                      {translate('integrations-app-title')}
                    </Text>
                    <Text
                      style={{
                        fontFamily: styles.primaryFont300,
                        backgroundColor: styles.primaryColorWithOpacity,
                        borderWidth: 1,
                        borderColor: styles.primaryColor,
                        borderRadius: 4,
                        paddingHorizontal: 10,
                        paddingVertical: 10,
                        fontSize: 12,
                        fontWeight: 'normal',
                      }}
                    >
                      {`curl -X POST -H "Content-Type: application/json" -d '{"inputs": {${inputs.map((input) => `"${input.n}": "<${input.d}>"`).join(',')}}}' ${API_URL}/rest/${app.data.uuid}/${endpoint.data.uuid}`}
                    </Text>
                  </View>
                )}
              </ScrollFading>
              {/* <View style={{
                backgroundColor: 'white',
                width: '100%',
                justifyContent: 'center',
                flexDirection: 'row',
              }}
              >
                {app.pp.endpoints && app.pp.endpoints.length > 1 && (
                  <ButtonGroup
                    textStyle={{ fontSize: 14 }}
                    selectedIndex={travelType}
                    buttons={buttons}
                  />
                )}
              </View> */}
              {displayingQuery && user && (
                <View style={{
                  backgroundColor: 'white',
                  width: '100%',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  ...ifIphoneX({
                    paddingBottom: 10,
                  }),
                }}
                >
                  <Button
                    title={translate('button_back')}
                    containerStyle={styles.button.secondaryContainer}
                    buttonStyle={styles.button.secondary}
                    titleStyle={styles.button.secondaryTitle}
                    onPress={() => {
                      getAnalyticsService().report.event('cancel', 'appquery');
                      history.push(`/ai-agent/${app.data.uuid}/`);
                      // history.goBack();
                    }}
                  />
                  {/* <Button
                    title={translate('button_history')}
                    containerStyle={styles.button.secondaryContainer}
                    buttonStyle={styles.button.secondary}
                    titleStyle={styles.button.secondaryTitle}
                    onPress={() => {
                      getAnalyticsService().report.event('history', 'appquery');
                      history.push(`/ai-agent/${app.data.uuid}/history`);
                      // history.goBack();
                    }}
                  /> */}
                  <Button
                    title={translate('button_send')}
                    containerStyle={styles.button.primaryContainer}
                    buttonStyle={styles.button.primary}
                    titleStyle={styles.button.primaryTitle}
                    loading={starting}
                    onPress={() => {
                      getAnalyticsService().report.event('history', 'appquery');

                      if (
                        existingLease
                        || app.data.user === user.attributes.sub
                        || userData.auditor === '*'
                        || userData.auditor === app.data.lang) {
                        // We already have a lease or we don't need one, so we can proceed with the query
                        this.query(app, endpoint);
                      } else if (app.pp.type === 0) {
                        // TODO(clairbee): create a free lease
                        onCreateFreeLease()
                          .then((_result) => {
                            // The lease has been created, so we can proceed with the query
                            this.query(app, endpoint);
                          });
                      } else {
                        this.setState({ isModalVisible: true });
                      }
                    }}
                  />
                </View>
              )}
              {displayingQuery && !user && (
                <View style={{
                  backgroundColor: 'white',
                  width: '100%',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  ...ifIphoneX({
                    paddingBottom: 10,
                  }),
                }}
                >
                  <Button
                    title={translate('menu_signin')}
                    containerStyle={styles.button.primaryContainer}
                    buttonStyle={styles.button.primary}
                    titleStyle={styles.button.primaryTitle}
                    onPress={() => {
                      getAnalyticsService().report.event('signin', 'appquery');
                      history.push(`/signin/ai-agent/online/${app.data.uuid}/${endpoint.data.uuid}`);
                    }}
                  />
                </View>
              )}
            </View>
          </View>
        </View>

        {isModalVisible && (
          <Modal
            style={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              alignSelf: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#fffc',
              borderWidth: 0,
            }}
            transparent
            presentationStyle="overFullScreen"
            visible
          >
            <View
              style={{
                flex: 1,
                position: 'relative',
                alignSelf: 'center',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'center',
              }}
            >
              <View
                style={{
                  position: 'relative',
                  alignSelf: 'center',
                  backgroundColor: 'white',
                  padding: 24,
                  paddingBottom: 12,
                  borderColor: styles.primaryColor,
                  borderWidth: 8,
                }}
              >
                <Text style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
                >
                  {translate('app_info_modal_unavailable')}
                  {/* {translate('app_info_modal')} */}
                </Text>

                <View
                  style={{
                    justifyContent: 'center',
                    flexDirection: 'row',
                    paddingTop: 24,
                  }}
                >
                  {app.pp.type >= 4 && (
                    <Button
                      disabled
                      title={`${translate('button_query')}\n(${app.pp.queryPrice} ${app.pp.currency})`}
                      containerStyle={styles.button.primaryContainer}
                      buttonStyle={styles.button.primary}
                      titleStyle={styles.button.primaryTitle}
                      loading={starting}
                      onPress={() => {
                        getAnalyticsService().report.event('history', 'appquery');
                        history.push(`/ai-agent/saved/${app.data.uuid}`);
                        // history.goBack(); ???
                      }}
                    />
                  )}
                  {(app.pp.type % 2) === 1 && (
                    <Button
                      disabled
                      title={`${translate('button_rent', { days: app.pp.rentPeriod })}\n(${app.pp.rentPrice} ${app.pp.currency})`}
                      containerStyle={styles.button.primaryContainer}
                      buttonStyle={styles.button.primary}
                      titleStyle={styles.button.primaryTitle}
                      loading={starting}
                      onPress={() => {
                        getAnalyticsService().report.event('history', 'appquery');
                        history.push(`/ai-agent/saved/${app.data.uuid}`);
                        // history.goBack(); ???
                      }}
                    />
                  )}
                  {(app.pp.type % 2) === 0 && (app.pp.type % 4) !== 0 && (
                    <Button
                      disabled
                      title={`${translate('button_buy')}\n(${app.pp.buyPrice} ${app.pp.currency})`}
                      containerStyle={styles.button.primaryContainer}
                      buttonStyle={styles.button.primary}
                      titleStyle={styles.button.primaryTitle}
                      loading={starting}
                      onPress={() => {
                        getAnalyticsService().report.event('history', 'appquery');
                        history.push(`/ai-agent/saved/${app.data.uuid}`);
                        // history.goBack(); ???
                      }}
                    />
                  )}
                </View>
                <View
                  style={{
                    justifyContent: 'center',
                    flexDirection: 'row',
                    // paddingTop: 24,
                  }}
                >
                  <Button
                    title={translate('button_back')}
                    containerStyle={styles.button.secondaryContainer}
                    buttonStyle={styles.button.secondary}
                    titleStyle={styles.button.secondaryTitle}
                    onPress={() => {
                      this.setState({ isModalVisible: false });
                    }}
                  />
                </View>
              </View>
            </View>
          </Modal>
        )}
      </KeyboardAvoidingView>
    );
  }
}

AppQuery.defaultProps = {
  // TODO(clairbee): Even though 'app' is always supplied, we need a temporary value before graphql finishes loading
  app: window && window.app_PRELOADED ? App.createFromData(window.app_PRELOADED) : undefined,
  user: null,
  userData: null,
  existingLease: null,
};

AppQuery.propTypes = {
  app: PropTypes.instanceOf(App),
  history: ReactRouterPropTypes.history.isRequired,
  direction: PropTypes.string.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
  // location: ReactRouterPropTypes.location.isRequired,
  user: AORTypes.AWS.Cognito.User,
  userData: AORTypes.User,
  onCreateFreeLease: PropTypes.func.isRequired,
  onQueryMyHistory: PropTypes.func.isRequired,
  onQueryMyHistoryRefetch: PropTypes.func.isRequired,
  onUpdateOutput: PropTypes.func.isRequired,
  existingLease: AORTypes.MyLeases,
  location: ReactRouterPropTypes.location.isRequired,
};

export default compose(
  graphql(GetApp, {
    skip: window && window.app_PRELOADED,
    // props: props => ({
    //   app: props.data.getMyApps,
    // }),
    props: (props) => {
      console.log('graphql props');
      console.log(props);
      if (!props.data.getApps) {
        return {};
      }
      const app = App.createFromData(props.data.getApps);
      if (app && app.data && app.data.endpoints === undefined) {
        app.data.endpoints = [];
      }
      return {
        app,
      };
    },
    options: (props) => {
      const { location } = props;
      const match = matchPath('/ai-agent/online/:uuid/:endpointUuid/:page?/:itemIndex?', location.pathname);
      const uuid = match ? match.params.uuid : undefined;

      return {
        variables: {
          uuid,
        },
        client: AppSyncClientUnauthenticated,
        fetchPolicy: 'cache-and-network',
        // fetchPolicy: 'network-only',
      };
    },
    // client: AppSyncClientUnauthenticated(props.user),
  }),
  graphql(CheckMyLease, {
    skip: (props) => !props.user,
    props: (props) => ({
      existingLease: props.data.checkMyLease,
    }),
    options: (props) => {
      const { location } = props;

      const match = matchPath('/ai-agent/online/:uuid/:endpointUuid/:page?/:itemIndex?', location.pathname);
      const uuid = match ? match.params.uuid : undefined;

      return {
        variables: {
          uuid,
        },
        client: AppSyncClientAuthenticated(props.user),
        // fetchPolicy: 'no-cache',
        fetchPolicy: 'cache-and-network',
      };
    },
    // client: AppSyncClientAuthenticated(),
  }),
  graphql(CreateFreeLease, {
    // name: 'CreateFreeLease',
    props: (props) => {
      const { location } = props.ownProps;

      const match = matchPath('/ai-agent/online/:uuid/:endpointUuid/:page?/:itemIndex?', location.pathname);
      const uuid = match ? match.params.uuid : undefined;

      return {
        onCreateFreeLease: () => props.mutate({
          variables: {
            uuid,
          },
        }),
      };
    },
    options: (props) => {
      const { location } = props;

      const match = matchPath('/ai-agent/online/:uuid/:endpointUuid/:page?/:itemIndex?', location.pathname);
      const uuid = match ? match.params.uuid : undefined;

      return {
        refetchQueries: [{
          query: CheckMyLease,
          variables: {
            uuid,
          },
          client: AppSyncClientAuthenticated(props.user),
        }, {
          query: QueryMyLeases,
          client: AppSyncClientAuthenticated(props.user),
        }],
        fetchPolicy: 'no-cache',
        client: AppSyncClientAuthenticated(props.user),
      };
    },
  }),
  graphql(UpdateLease, {
    // name: 'UpdateLease',
    props: (props) => ({
      onUpdateLease: ({ endpointsCompleted, completed }) => {
        const { location } = props.ownProps;

        const match = matchPath('/ai-agent/online/:uuid/:endpointUuid/:page?/:itemIndex?', location.pathname);
        const uuid = match ? match.params.uuid : undefined;

        return props.mutate({
          variables: {
            uuids: `${props.ownProps.user.attributes.sub}-${uuid}`,
            endpointsCompleted,
            completed,
          },
          // TODO(clairbee): optimisticResponse breaks refetchQueries
          // optimisticResponse: () => ({
          //   existingLease:{...}}
          // }),
        });
      },
    }),
    options: (props) => {
      const { location } = props;

      const match = matchPath('/ai-agent/online/:uuid/:endpointUuid/:page?/:itemIndex?', location.pathname);
      const uuid = match ? match.params.uuid : undefined;

      return {
        refetchQueries: [{
          query: CheckMyLease,
          variables: {
            uuid,
          },
          client: AppSyncClientAuthenticated(props.user),
        }, {
          query: QueryMyLeases,
          client: AppSyncClientAuthenticated(props.user),
        }],
        fetchPolicy: 'no-cache',
        client: AppSyncClientAuthenticated(props.user),
      };
    },
  }),
  graphql(QueryMyHistory, {
    skip: (props) => !props.user,
    props: (props) => ({
      onQueryMyHistory: props.data.queryMyHistory,
      onQueryMyHistoryRefetch: props.data.refetch,
    }),
    options: (props) => {
      const { location } = props;

      const match = matchPath('/ai-agent/online/:uuid/:endpointUuid/:page?/:itemIndex?', location.pathname);
      const uuid = match ? match.params.uuid : undefined;
      const uuidEndpoint = match ? match.params.endpointUuid : undefined;

      return {
        variables: {
          uuidApp: uuid,
          uuidEndpoint,
        },
        client: AppSyncClientAuthenticated(props.user),
        fetchPolicy: 'no-cache',
      };
    },
  }),
  graphql(UpdateOutput, {
    name: 'onUpdateOutput',
    props: (props) => ({
      onUpdateOutput: (uuidApp, uuidEndpoint, idRequest) => {
        // const { location } = props.ownProps;

        // const match = matchPath('/ai-agent/online/:uuid/:endpointUuid/:page?/:itemIndex?', location.pathname);
        // const uuidApp = match ? match.params.uuid : undefined;
        // const uuidEndpoint = match ? match.params.endpointUuid : undefined;

        console.log('onUpdateOutput');
        console.log(props);

        return props.onUpdateOutput({
          variables: {
            uuidApp,
            uuidEndpoint,
            idRequest,
          },
        });
      },
    }),
    options: (props) => {
      const { location } = props;

      const match = matchPath('/ai-agent/online/:uuid/:endpointUuid/:page?/:itemIndex?', location.pathname);
      const uuidApp = match ? match.params.uuid : undefined;
      const uuidEndpoint = match ? match.params.endpointUuid : undefined;

      return {
        refetchQueries: [{
          query: QueryMyHistory,
          variables: {
            uuidApp,
            uuidEndpoint,
          },
          client: AppSyncClientAuthenticated(props.user),
        }],
        fetchPolicy: 'no-cache',
        client: AppSyncClientAuthenticated(props.user),
      };
    },
  })
)(AppQuery);
